export default function ($translate) {
    return {
        KEYS: {
            ALL_SITES: 'ALL_SITES',
            SPECIFIED_SITES: 'SPECIFIED_SITES'
        },
        LABELS: {
            ALL_SITES: $translate.instant('form.All sites'),
            SPECIFIED_SITES: $translate.instant('form.Specified sites')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/form/siteAccess/index.js